import { useId } from 'react';
import { Box, TextField, Typography, type TextFieldProps } from '@mui/material';
import { tokens } from '../theme';

type Props = Omit<TextFieldProps, 'label' | 'variant' | 'id'> & { label: string };

/**
 * Ô nhập có nhãn TĨNH đặt phía trên, không dùng nhãn nổi của MUI.
 *
 * Nhãn nổi (nhãn thu nhỏ rồi cắt vào đường viền) tính khe hở trên viền theo cỡ chữ
 * mặc định; dự án nâng cỡ chữ ô nhập lên 16px để iOS không tự phóng to, và khe hở đó
 * không mở đúng nữa nên chữ nhãn nằm đè lên viền.
 *
 * Nhãn tĩnh cũng đúng với demo của BA (khối `.field-label`) và dễ đọc hơn: nhãn không
 * bao giờ biến mất khi ô có nội dung.
 */
export function LabeledField({ label, sx, ...rest }: Props) {
  const id = useId();
  return (
    <Box sx={sx}>
      <Typography
        component="label"
        htmlFor={id}
        sx={{
          display: 'block',
          fontSize: 13,
          fontWeight: 500,
          color: tokens.muted,
          mb: 0.6,
        }}
      >
        {label}
      </Typography>
      <TextField
        {...rest}
        id={id}
        fullWidth={rest.fullWidth ?? true}
        // 16px trở lên để iOS không tự phóng to khi bấm vào ô nhập.
        slotProps={{
          ...rest.slotProps,
          input: { sx: { fontSize: 16 }, ...rest.slotProps?.input },
          formHelperText: { sx: { ml: 0, fontSize: 12.5 }, ...rest.slotProps?.formHelperText },
        }}
      />
    </Box>
  );
}
